import {Mapper} from '@s-ui/domain'

export class FromRawDistributorCarouselsToCarouselsInfoVOMapper extends Mapper {
  constructor({carouselInfoValueObject, carouselsInfoValueObject, latestModelValueObject}) {
    super()
    this._carouselInfoValueObject = carouselInfoValueObject
    this._carouselsInfoValueObject = carouselsInfoValueObject
    this._latestModelValueObject = latestModelValueObject
  }

  map = ({data}) => {
    const carousels = data.carousels.map(({title, items}) => {
      const carouselItems = items.map(({image, make, makeId, minPrice, model, modelId, url, spotOfferPrice}) => {
        return this._latestModelValueObject({
          image,
          make,
          makeId,
          model,
          modelId,
          price: minPrice,
          offerPrice: spotOfferPrice,
          url
        })
      })

      return this._carouselInfoValueObject({title, items: carouselItems})
    })

    return this._carouselsInfoValueObject({carousels})
  }
}
